var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiManagement01 = function SvgAiManagement01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai_management-01_svg2__a",
    x1: 43.11,
    x2: 147.07,
    y1: 196.05,
    y2: 83.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ai_management-01_svg2__a",
    id: "ai_management-01_svg2__b",
    x1: 13.24,
    x2: 117.2,
    y1: 168.55,
    y2: 55.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ai_management-01_svg2__a",
    id: "ai_management-01_svg2__c",
    x1: 23,
    x2: 126.96,
    y1: 177.53,
    y2: 64.64
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#ai_management-01_svg2__a",
    id: "ai_management-01_svg2__d",
    x1: 12.87,
    x2: 116.83,
    y1: 168.2,
    y2: 55.31
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M196.88 144.68c-6.96-6.26-15.8-7.67-26.42-4.15l-30.29 11.66c.04-.42.06-.85.06-1.28 0-7.65-6.22-13.88-13.87-13.88h-22.63c-1.97 0-3.78-.83-4.97-2.28-5.21-6.38-11.72-10.54-19.34-12.37-2.7-.65-5.64-.97-8.74-.97H36.9c-1.41-7.21-7.77-12.68-15.39-12.68H7.31c-4.03 0-7.31 3.28-7.31 7.31v72.31c0 4.03 3.28 7.31 7.31 7.31h14.21c8.06 0 14.65-6.13 15.52-13.97L79.85 195c14.49 4.5 30.44 3.74 44.84-2.85l69.8-31.9c6.16-2.81 7.41-11.04 2.37-15.57ZM30.97 179.96c0 5.21-4.24 9.45-9.45 9.45H7.31c-.59 0-1.06-.48-1.06-1.06v-72.31c0-.59.48-1.06 1.06-1.06h14.21c5.21 0 9.45 4.24 9.45 9.45v55.54Zm160.94-25.4-69.81 31.9a56.62 56.62 0 0 1-40.39 2.56l-44.49-13.83v-47.55h33.47c2.61 0 5.06.27 7.28.8 6.35 1.52 11.57 4.87 15.96 10.25 2.38 2.91 5.95 4.57 9.81 4.57h22.63c4.2 0 7.62 3.42 7.62 7.63s-3.42 7.63-7.63 7.63H73.77c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13h52.59c4.05 0 7.71-1.75 10.25-4.53l35.97-13.85c8.3-2.75 14.89-1.79 20.14 2.92 1.69 1.52 1.28 4.29-.79 5.23Z",
    style: {
      fill: "url(#ai_management-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.29 73.64c.46-.3.81-.71 1.06-1.25l2.91-6.98h15.21l2.92 7c.89 1.92 3.32 2.18 4.58.88.75-.79 1-1.88.48-3.13l-12.04-28.43c-.61-1.37-1.74-2.31-3.31-2.31h-.47c-1.57 0-2.7.95-3.31 2.32L94.28 70.16c-.19.45-.28.84-.28 1.18 0 .76.26 1.42.76 1.94.87.91 2.39 1.09 3.53.35Zm6.14-13.39 5.43-13.09 5.44 13.09z",
    style: {
      fill: "url(#ai_management-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.18 74.1c1.55 0 2.8-1.2 2.8-2.75V42.23c0-.76-.28-1.43-.82-1.98-1.09-1.09-2.88-1.09-3.94 0-.52.55-.79 1.21-.79 1.97v29.12c0 1.54 1.19 2.75 2.75 2.75Z",
    style: {
      fill: "url(#ai_management-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6 76.31c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13h9.68v3.46c0 7.7 6.26 13.96 13.95 13.96h3.46v9.68c0 1.73 1.4 3.13 3.13 3.13s3.13-1.4 3.13-3.13v-9.68h16.42v9.68c0 1.73 1.4 3.13 3.13 3.13s3.13-1.4 3.13-3.13v-9.68h16.42v9.68c0 1.73 1.4 3.13 3.13 3.13s3.13-1.4 3.13-3.13v-9.68h3.46c7.69 0 13.95-6.26 13.95-13.96v-3.46h9.68c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13h-9.68V59.89h9.68c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13h-9.68V37.21h9.68c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13h-9.68v-3.46c0-7.69-6.26-13.95-13.95-13.95h-3.46V3.88c0-1.73-1.4-3.13-3.13-3.13s-3.13 1.4-3.13 3.13v9.68h-16.42V3.88c0-1.73-1.4-3.13-3.13-3.13s-3.13 1.4-3.13 3.13v9.68H95.95V3.88c0-1.73-1.4-3.13-3.13-3.13s-3.13 1.4-3.13 3.13v9.68h-3.46c-7.69 0-13.95 6.26-13.95 13.95v3.46H62.6c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13h9.68v16.42H62.6c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13h9.68v16.42H62.6Zm15.93-48.8c0-4.25 3.46-7.7 7.7-7.7h58.5c4.25 0 7.7 3.46 7.7 7.7v58.5c0 4.25-3.46 7.71-7.7 7.71h-58.5c-4.25 0-7.7-3.46-7.7-7.71z",
    style: {
      fill: "url(#ai_management-01_svg2__d)"
    }
  }));
};
export default SvgAiManagement01;